import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormatMediumDatetimePipe } from '@date/format-medium-datetime.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHistory } from '@fortawesome/pro-solid-svg-icons';
import { TranslateDirective } from '@language/translate.directive';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'flw-auditing',
  templateUrl: './auditing.component.html',
  styleUrls: ['./auditing.component.scss'],
  imports: [TranslateDirective, FormatMediumDatetimePipe, NgIf, TooltipModule, FontAwesomeModule, OverlayPanelModule],
  standalone: true,
})
export class AuditingComponent {
  @Input() record?: any;

  constructor() {}

  protected readonly faHistory = faHistory;
}
